var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PostForm',{key:_vm.shouldRefreshPostForm,attrs:{"company-id":_vm.companyId},on:{"post-status-update":_vm.postStatusUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }